/* iFungi — LF7 AOV patch (2026-07-26, Claude)
 * 1) One-time-purchase quantity defaults to "1 Bag" (the native select
 *    default). [2026-08-06: the forced "2 Bags"/"3 Bags" default was removed
 *    per merchant decision — first-time shoppers now anchor on the smallest,
 *    least intimidating total and trade themselves up via the Save $ labels.]
 * 2) Re-add "Best Seller" (3 Bags) / "Best Value" (5 Bags) as a SECOND LINE
 *    inside the quantity flyout options (the 2026-07-16 removal was because
 *    they no longer fit on one line — a second line solves that).
 * 3) [2026-08-06] US market only: the Amazon logo stays visible but is NOT
 *    clickable (href stripped + pointer-events:none). Canada keeps the link.
 *
 * REMOVED 2026-08-07 (merchant decision — the running total read as more
 * off-putting than persuasive at the decision moment):
 *   - Relocation of the total price (.lf7-price-wrap) to sit directly under
 *     the quantity dropdown, with its "TOTAL:" label (.lf7-total-label).
 *   - The per-bag figure in brackets beside it, e.g. "($39.98/bag)"
 *     (.lf7-total-ppb) and the MutationObserver that kept it in sync.
 *   - The "✓ FREE SHIPPING" reassurance line under it (.lf7-free-ship).
 * The .lf7-price-wrap element still renders in snippets/lf7-buybox-right-col
 * .liquid and ifungi-buybox.js still writes the total into #lf7-price —
 * the wrapper is simply kept hidden by the CSS below, so nothing downstream
 * breaks and the change is trivially reversible (delete the injected rule to
 * put the total back at the top of the buy box).
 * Free shipping is still stated by the FREE SHIPPING badge in the buy-box top
 * bar and by the cart drawer's own free-shipping row.
 *
 * Implemented as a standalone add-on so ifungi-buybox.js stays untouched.
 * Loaded from the lf7-buybox-right-col snippet with defer.
 * Applies everywhere the LF7 buy box renders: LF7 product page AND homepage.
 */
(function () {
  if (window.__lf7AovPatch) return;
  window.__lf7AovPatch = true;

  /* The total price (.lf7-price-wrap) is hidden by snippets/lf7-buybox-right-col.liquid's own
     <style>, rendered with the buy box; the copy this script used to inject was removed 2026-10-21. */

  function init() {
    var lang = (document.documentElement.lang || 'en').split('-')[0];

    var BADGES = {
      '3 Bags': lang === 'fr' ? 'Meilleur vendeur' : 'Best Seller',
      '5 Bags': lang === 'fr' ? 'Meilleure valeur' : 'Best Value'
    };

    /* ---- 2nd-line badges in the qty flyout ---- */
    function decorate(panel) {
      Object.keys(BADGES).forEach(function (val) {
        var li = panel.querySelector('.lf7-cdd-option[data-value="' + val + '"]');
        if (!li) return;
        var txt = li.querySelector('.lf7-cdd-option__text');
        if (!txt || txt.querySelector('.lf7-cdd-badge2')) return;
        var b = document.createElement('span');
        b.className = 'lf7-cdd-badge2 lf7-cdd-badge2--' + (val === '3 Bags' ? 'seller' : 'value');
        b.textContent = BADGES[val];
        txt.appendChild(b);
      });
    }
    document.querySelectorAll('.lf7-cdd--qty .lf7-cdd-panel').forEach(function (panel) {
      decorate(panel);
      /* rebuildPanel() wipes the list on every open/size change — re-decorate */
      new MutationObserver(function () { decorate(panel); })
        .observe(panel, { childList: true });
    });

    /* ---- Pack total under the quantity dropdown (2026-10-21) ----
       2/3/5 bags (one-time) show "$269.95 for 3 bags" in small text. The amount is copied from the
       hidden #lf7-price, which ifungi-buybox.js keeps current for the chosen size and bag count. */
    var priceEl = document.getElementById('lf7-price');
    var totalEl = document.getElementById('lf7-pack-total');
    var qtySel = document.getElementById('lf7-qty-select');
    if (priceEl && totalEl && qtySel) {
      var syncTotal = function () {
        var opt = qtySel.options[qtySel.selectedIndex];
        var bags = opt ? parseInt(opt.getAttribute('data-bags'), 10) || 1 : 1;
        var price = priceEl.textContent.trim();
        if (bags < 2 || !/\d/.test(price)) { totalEl.hidden = true; return; }
        var words = lang === 'fr' ? ' pour ' + bags + ' sachets' : ' for ' + bags + ' bags';
        if (totalEl.textContent.trim() !== price + words) {
          totalEl.textContent = '';
          var amount = document.createElement('span');
          amount.className = 'lf7-pack-total__price';
          amount.textContent = price;
          totalEl.appendChild(amount);
          totalEl.appendChild(document.createTextNode(words));
        }
        totalEl.hidden = false;
      };
      new MutationObserver(syncTotal).observe(priceEl, { childList: true, characterData: true, subtree: true });
      qtySel.addEventListener('change', function () { setTimeout(syncTotal, 0); });
      syncTotal();
    }

    /* ---- One-time qty default ----
       2026-08-06: forced-default block removed per merchant decision. The
       native <select> default ("1 Bag") is used as-is, and the shopper's own
       choice is never overridden. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor (2026-10-22): a re-rendered LF7 buy box gets its badges and pack total again
     (decorate() skips rows it already did). */
  document.addEventListener('shopify:section:load', init);
})();
